// extracted by mini-css-extract-plugin
module.exports = {"card":"country_card__2_EPn"};